import { transformObjectToCamelCase } from '@utilities';

import axios from './api';
import { transformInstantSurvey } from './utilities/helpers';

/**
 * create question group
 * @param {Object} options
 * @param {string} options.name
 * @param {null | number} [options.parentGroup]
 * @param {boolean} [options.randomizeOrder]
 * @param {AbortSignal} [options.signal]
 * @return {Promise<{ id: number, name: string, parentGroup: null | number, randomizeOrder: boolean }>}
 */
export const createQuestionGroup = async ({
  name,
  parentGroup,
  randomizeOrder = false,
  signal,
}) => {
  const data = {
    name,
    randomize_order: randomizeOrder,
  };
  if (parentGroup !== undefined) data.parent_group = parentGroup;

  return axios({
    data,
    method: 'post',
    signal,
    url: '/instantsurvey/question_group/',
  }).then(({ data }) => transformObjectToCamelCase(data));
};

/**
 * update question group
 * @param {Object} options
 * @param {number} options.id
 * @param {string} [options.name]
 * @param {null | number} [options.parentGroup]
 * @param {boolean} [options.randomizeOrder]
 * @param {AbortSignal} [options.signal]
 * @return {Promise<{ id: number, name: string, parentGroup: null | number, randomizeOrder: boolean }>}
 */
export const updateQuestionGroup = async ({ id, name, parentGroup, randomizeOrder, signal }) => {
  const data = {};
  if (name !== undefined) data.name = name;
  if (randomizeOrder !== undefined) data.randomize_order = randomizeOrder;
  if (parentGroup !== undefined) data.parent_group = parentGroup;

  return axios({
    data,
    method: 'patch',
    signal,
    url: `/instantsurvey/question_group/${id}/`,
  }).then(({ data }) => transformObjectToCamelCase(data));
};

/**
 * delete question group
 * @param {Object} options
 * @param {number} options.id
 * @param {AbortSignal} [options.signal]
 * @return {Promise}
 */
export const deleteQuestionGroup = async ({ id, signal }) => {
  return axios({
    method: 'delete',
    signal,
    url: `/instantsurvey/question_group/${id}/`,
  });
};

/**
 * Atomically deletes a question group and its member questions from a survey.
 * @param {Object} options
 * @param {number} options.questionGroupId
 * @param {boolean} [options.isMultiLevelDisqualifyEnabled]
 * @param {AbortSignal} [options.signal]
 * @param {number} options.surveyId
 * @return {Promise<Object>} Updated survey state
 */
export const deleteQuestionGroupFromSurvey = async ({
  isMultiLevelDisqualifyEnabled = true,
  questionGroupId,
  signal,
  surveyId,
}) => {
  return axios({
    method: 'delete',
    signal,
    url: `/instantsurvey/instantsurvey/${surveyId}/question_group/${questionGroupId}/`,
  }).then(({ data }) => transformInstantSurvey(data, { isMultiLevelDisqualifyEnabled }));
};
